/**
 * QUOTATION API — Wrapper dei REST pubblicati da `QuotationsResourceImpl`
 * (modulo crm-rest). I 5 metodi CRUD standard vengono da `createCrudApi`.
 *
 * Contratto backend (rest-openapi.yaml + QuotationsResourceImpl):
 *   - GET    /quotations/{groupId}    (+ page, pageSize, sort, search)  -> Page<Quotation>
 *   - POST   /quotations/{groupId}    QuotationInput                    -> Quotation
 *   - GET    /quotation/{quotationId}                                   -> Quotation
 *   - PATCH  /quotation/{quotationId} QuotationInput (parziale)         -> Quotation
 *   - DELETE /quotation/{quotationId}                                   -> 200
 *
 * Il `search` filtra su externalCode/title/notes e i plugin abilitati possono
 * estenderlo (QuotationSearchContributor, backend). `quotationUpdateToInput`
 * ignora `quotationId` (whitelist), quindi passare il payload intero equivale
 * allo strip esplicito precedente.
 */

import { createCrudApi } from '../../store/createCrudApi';
import {
  quotationFromDto,
  quotationCreateToInput,
  quotationUpdateToInput,
  type QuotationDto,
  type Quotation,
} from './quotationMappers';
import type {
  QuotationCreatePayload,
  QuotationUpdatePayload,
  QuotationListParams,
} from './quotationTypes';

export const quotationApi = createCrudApi<
  Quotation,
  QuotationDto,
  QuotationCreatePayload,
  QuotationUpdatePayload,
  QuotationListParams
>({
  collection: '/quotations',
  single: '/quotation',
  fromDto: quotationFromDto,
  createToInput: quotationCreateToInput,
  updateId: (p) => p.quotationId,
  updateToInput: (p) => quotationUpdateToInput(p),
});
